import { render, staticRenderFns } from "./AssociateParentModal.vue?vue&type=template&id=1380ec30&scoped=true"
import script from "./AssociateParentModal.vue?vue&type=script&lang=js"
export * from "./AssociateParentModal.vue?vue&type=script&lang=js"
import style0 from "./AssociateParentModal.vue?vue&type=style&index=0&id=1380ec30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380ec30",
  null
  
)

export default component.exports